import {storageFactory} from "./storage"

export const localStore = storageFactory(() => localStorage);
